var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.364 18.3643C14.8492 21.8791 9.15076 21.8791 5.63604 18.3643C2.12132 14.8496 2.12132 9.15114 5.63604 5.63642C9.15076 2.1217 14.8492 2.1217 18.364 5.63642C21.8787 9.15114 21.8787 14.8496 18.364 18.3643ZM7.75736 16.243C7.36683 15.8525 7.36683 15.2193 7.75736 14.8288L10.5858 12.0004L7.75736 9.17196C7.36684 8.78143 7.36683 8.14827 7.75736 7.75774C8.14788 7.36722 8.78105 7.36722 9.17157 7.75774L12 10.5862L14.8284 7.75774C15.219 7.36722 15.8521 7.36722 16.2426 7.75774C16.6332 8.14827 16.6332 8.78143 16.2426 9.17196L13.4142 12.0004L16.2426 14.8288C16.6332 15.2193 16.6332 15.8525 16.2426 16.243C15.8521 16.6335 15.219 16.6335 14.8284 16.243L12 13.4146L9.17157 16.243C8.78105 16.6335 8.14788 16.6335 7.75736 16.243Z",
    fill: "#E60033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0563e828b3ed86fe7fc6b958996d424b.svg";
export { ForwardRef as ReactComponent };